import api from '../configs/api.config';
import { WEFResponse } from '../Types';
import { TicketsWaitingForInvoicingResponse } from '../types/invoicing.types';

export const getTicketsWaitingForInvoicing =
  async (): Promise<TicketsWaitingForInvoicingResponse> => {
    const { data } = await api.get<WEFResponse<TicketsWaitingForInvoicingResponse>>(
      '/Analytics/tickets-waiting-for-invoicing'
    );
    return data.data;
  };
